/**
 * Application-wide constants
 */

/**
 * Default number of items per page for paginated lists
 */
export const PAGE_SIZE = 15;

/**
 * Abbreviated month names
 */
export const MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Number of days in a billing period that triggers a warning
 */
export const BILLING_PERIOD_WARNING_THRESHOLD = 100;

/**
 * Yes/No dropdown options
 */
export const YES_NO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
] as const;

/**
 * Month options for dropdowns
 */
export const MONTH_OPTIONS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
] as const;

/**
 * Generate year options for dropdowns
 * @param pastYears Number of past years to include (default: 1)
 * @param futureYears Number of future years to include (default: 5)
 * @returns Array of year options
 */
export const generateYearOptions = (pastYears = 1, futureYears = 5) => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: pastYears + futureYears + 1 }, (_, i) => {
    const year = currentYear - pastYears + i;
    return { value: String(year), label: String(year) };
  });
};
